import IframeActivity from "./IframeActivity";

export default function TimeIsMoney() {
    return (
        <IframeActivity
            src="/activities/time-is-money/index.html"
            title="Time is Money"
        />
    );
}